import { FeatureFlagServiceApiVersion } from './types';
export var CURRENT_FFS_API_VERSION = FeatureFlagServiceApiVersion.V2;